import React from 'react'
import {
  Box,
} from '@mui/material'
import {
  AutoCoderFramework,
  FrameworkEngineConfig,
  CarbonInterviewRawDataRow,
  SourceVariable,
} from '../../../types/gotypes'
import { AutoCoderFrameworkLibrary } from '../../../hooks/useFrameworkLibrary'
import FrameworkComposer from './FrameworkComposer'

interface PipelineFrameworkStepProps {
  frameworkEngine: FrameworkEngineConfig | undefined
  frameworks: AutoCoderFramework[]
  hasDataConfirmed: boolean
  previewData: CarbonInterviewRawDataRow[]
  variable: SourceVariable | undefined
  customer: string
  job: string
  pipelineId: string
  onFrameworkEngineChange: (config: FrameworkEngineConfig) => void
  onFrameworksChange: (frameworks: AutoCoderFramework[]) => void
  disabled?: boolean
  // Framework library props
  frameworkLibrary?: AutoCoderFrameworkLibrary[]
  frameworkLibraryLoading?: boolean
}

const PipelineFrameworkStep: React.FC<PipelineFrameworkStepProps> = ({
  frameworkEngine,
  frameworks,
  hasDataConfirmed,
  previewData,
  variable,
  customer,
  job,
  pipelineId,
  onFrameworkEngineChange,
  onFrameworksChange,
  disabled,
  frameworkLibrary = [],
  frameworkLibraryLoading = false,
}) => {
  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}
      data-testid="autocoder-pipeline-framework-step"
    >
      <FrameworkComposer
        frameworks={frameworks}
        frameworkLibrary={frameworkLibrary}
        frameworkLibraryLoading={frameworkLibraryLoading}
        onFrameworksChange={onFrameworksChange}
        disabled={disabled}
        frameworkEngine={frameworkEngine}
        onFrameworkEngineChange={onFrameworkEngineChange}
        hasDataConfirmed={hasDataConfirmed}
        previewData={previewData}
        variable={variable}
        customer={customer}
        job={job}
        pipelineId={pipelineId}
      />
    </Box>
  )
}

export default PipelineFrameworkStep
